import { render, staticRenderFns } from "./GatewayTransfer.vue?vue&type=template&id=4fb0ff75&scoped=true"
import script from "./GatewayTransfer.vue?vue&type=script&lang=js"
export * from "./GatewayTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0ff75",
  null
  
)

export default component.exports